import { AppConfig } from './../app.config';
import { AmChartsService } from '@amcharts/amcharts3-angular';
import { SnapshotService } from './../snapshot/snapshot.service';
import { DashboardEventService } from './../dashboard/dashboard-event.service';
import { ExplainService } from './explain.service';
import { ExplainData } from '@liquitics/transaction';
import { Observable, forkJoin } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ExplainComponent } from './explain.component';
import * as moment from 'moment';
import {
    trigger,
    state,
    style,
    animate,
    transition
} from '@angular/animations';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-compare-explain',
    templateUrl: './compare-explain.component.html',
    styleUrls: ['./explain.component.scss', './compare-explain.component.css'],
    animations: [
        trigger('flyInOut', [
            state('in', style({ opacity: 1, transform: 'translateX(0)' })),
            transition('void => *', [
                style({
                    opacity: 0,
                    transform: 'translateX(100%)'
                }),
                animate('0.2s ease-in')
            ]),
            transition('* => void', [
                style({
                    opacity: 0,
                    transform: 'translateX(-100%)'
                })
            ])
        ])
    ]
})
export class CompareExplainComponent extends ExplainComponent implements OnInit {
    private boundaryDatetime: moment.Moment;
    constructor(protected explainService: ExplainService,
        protected dashboardEventService: DashboardEventService,
        protected snapshotService: SnapshotService,
        protected amChartsService: AmChartsService,
        protected appConfig: AppConfig) {
        super(explainService, dashboardEventService, snapshotService, amChartsService, appConfig);
    }
    explain(currency: string, currencyIndex: number, date: string) {
        this.panelBlocked = true;
        this.explainedCurrency = currency;
        this.isSpot = date <= this.getSpotDate();
        this.explainedDate = moment(date).format('L');
        this.explainedRequestTime = moment().format('LLL');
        this.explainTablesComponent.selectedCurrencyIndex = currencyIndex;
        const liveExplain: Observable<ExplainData> = this.explainService.getExplainData(currency, date, date)
            .pipe(take(1));
        const cobExplain: Observable<ExplainData> = this.explainService.getExplainData(currency, date, date, null, this.boundaryDatetime)
            .pipe(take(1));

        forkJoin(liveExplain, cobExplain)
            .subscribe({
                next: (data: ExplainData[]) => {
                    this.isSpot = date <= this.getSpotDate();
                    this.liquidityMode = 'net';
                    this.showExplain(this.explainService.diffExplainData(data[0], data[1]));
                }, error: (err) => {
                    this.panelBlocked = false;
                }, complete: () => {
                    this.panelBlocked = false;
                }
            })
            ;
    }

    ngOnInit() {
        super.ngOnInit();
        this.subscription.add(this.dashboardEventService.explainTimeShiftSubject.subscribe({
            next: boundaryDatetime => {
                this.boundaryDatetime = boundaryDatetime;
            }
        }));
    }

    protected chartDivName() {
        return 'comparechartdiv';
    }
}
